import React from 'react';

const SVG = ({ width = '55px', height = '55px', className = '', viewBox = '0 0 82 82', color = '#3A4249' }) => (
  <svg height={height} width={width} viewBox={viewBox} className={className}>
    <defs>
      <path
        d='M41,82 C52.3218374,82 62.5718374,77.4109187 69.991378,69.991378 C77.4109187,62.5718374 82,52.3218374 82,41 C82,29.6781626 77.4109187,19.4281626 69.991378,12.008622 C62.5718374,4.58908131 52.3218374,0 41,0 C29.6781626,0 19.4281626,4.58908131 12.008622,12.008622 C4.58908131,19.4281626 0,29.6781626 0,41 C0,63.6436747 18.3563253,82 41,82 Z'
        id='path-1'
      ></path>
      <path
        d='M15,41 L22,59.6345027 L21.3,60.3512143 L15.748,54.666 L15.7484566,67 L13.4151232,67 L13.415,55.523 L8.7,60.3512143 L8,59.6345027 L15,41 Z'
        id='path-3'
      ></path>
    </defs>
    <g id='workflow' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Page-5.2' transform='translate(-97.000000, -355.000000)'>
        <g id='Group-17' transform='translate(20.000000, 115.000000)'>
          <g id='Group-3' transform='translate(0.000000, 131.000000)'>
            <g id='contextual-draw' transform='translate(77.000000, 109.000000)'>
              <mask id='mask-2' fill='white'>
                <use href='#path-1' xlinkHref='#path-1'></use>
              </mask>
              <use id='Mask' fill='#EFEFEF' href='#path-1' xlinkHref='#path-1'></use>
              <g id='Group-48' mask='url(#mask-2)'>
                <g transform='translate(12.000000, -6.000000)'>
                  <path
                    d='M5.25,83.9999958 C7.25,79.3333292 9.91666667,75.6666625 13.25,72.9999958 C18.25,68.9999958 20.25,54.9999958 23.25,54.9999958 C26.25,54.9999958 21.25,47.9999958 25.25,49.9999958 C29.25,51.9999958 29.25,58.9999958 32.25,56.9999958 C35.25,54.9999958 32.25,49.9999958 35.25,49.9999958 C38.25,49.9999958 45.25,53.9999958 49.25,51.9999958 C53.25,49.9999958 51.25,43.9999958 55.25,43.9999958 C59.25,43.9999958 55.8649311,46.9836625 62.25,48.9999958 C66.5067126,50.3442236 70.5067126,50.677557 74.25,49.9999958'
                    id='Path-16'
                    stroke='#979797'
                    strokeWidth='1'
                  ></path>
                  <path
                    d='M11.25,0 C11.25,4.66666667 11.9166667,6.33333333 13.25,5 C15.25,3 17.25,8 15.25,8 C13.25,8 7.25,16 11.25,14 C15.25,12 15.25,12 15.25,14 C15.25,16 21.25,12 21.25,14 C21.25,16 11.25,20 13.25,25 C15.25,30 17.25,31 19.25,30 C21.25,29 23.25,29 23.25,32 C23.25,35 19.25,34 19.25,37 C19.25,40 23.25,40 21.25,42'
                    id='Path-17'
                    stroke='#979797'
                    strokeWidth='1'
                  ></path>
                  <path
                    d='M0.25,104 C-0.416666667,101.333333 0.25,99.3333333 2.25,98 C5.25,96 5.25,92 5.25,89 C5.25,86 5.25,81 9.25,77 C13.25,73 15.25,71 15.25,64 C15.25,57 10.25,44 27.25,41 C44.25,38 32.25,38 37.25,35 C42.25,32 33.25,32 37.25,29 C41.25,26 46.25,24 46.25,16 C46.25,10.6666667 46.25,7 46.25,5'
                    id='Path-15'
                    stroke='#AADACC'
                    strokeWidth='13'
                  ></path>
                  <path
                    d='M0.25,104 C-0.416666667,101.333333 0.25,99.3333333 2.25,98 C5.25,96 5.25,92 5.25,89 C5.25,86 5.25,81 9.25,77 C13.25,73 15.25,71 15.25,64 C15.25,57 10.25,44 27.25,41 C44.25,38 32.25,38 37.25,35 C42.25,32 33.25,32 37.25,29 C41.25,26 46.25,24 46.25,16 C46.25,10.6666667 46.25,7 46.25,5'
                    id='Path-15'
                    stroke='#285C4D'
                    strokeWidth='3'
                  ></path>
                  <g
                    id='Combined-Shape'
                    stroke='none'
                    transform='translate(15.000000, 54.000000) rotate(45.000000) translate(-15.000000, -54.000000) '
                  >
                    <path
                      stroke='#A8A8A8'
                      strokeWidth='3.60000014'
                      d='M15,35.8813409 L5.91239207,60.0732057 L8.70008662,62.9274531 L11.6150474,59.9424997 L11.6151425,68.8000001 L17.5485233,68.8000001 L17.5481637,59.0856615 L21.2999244,62.9274417 L24.0876079,60.0732057 L15,35.8813409 Z'
                      fill='#232124'
                      fillRule='evenodd'
                    ></path>
                    <path
                      stroke='#FFFFFF'
                      strokeWidth='2.4000001'
                      d='M15,37.5875606 L6.60826138,59.9269714 L8.70005774,62.0687068 L12.2150316,58.4693331 L12.2151361,68.2 L16.948501,68.2 L16.9481091,57.612441 L21.2999496,62.0686993 L23.3917386,59.9269714 L15,37.5875606 Z'
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SVG;
